import { render, staticRenderFns } from "./studentClasss.vue?vue&type=template&id=72b78748&scoped=true"
import script from "./studentClasss.vue?vue&type=script&lang=js"
export * from "./studentClasss.vue?vue&type=script&lang=js"
import style0 from "./studentClasss.vue?vue&type=style&index=0&id=72b78748&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b78748",
  null
  
)

export default component.exports